/**
 * パスワード自動生成関数
 * 大文字、小文字、数字を含む安全なパスワードを生成します
 * @returns 自動生成されたパスワード
 */
export const generatePassword = (): string => {
  // 使用する文字セット
  const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  
  // 最低限必要な文字を確保
  let password = '';
  password += upperChars.charAt(Math.floor(Math.random() * upperChars.length)); // 大文字
  password += lowerChars.charAt(Math.floor(Math.random() * lowerChars.length)); // 小文字
  password += numbers.charAt(Math.floor(Math.random() * numbers.length)); // 数字
  
  // 残りの文字を生成（合計12文字）
  const allChars = upperChars + lowerChars + numbers;
  for (let i = 0; i < 9; i++) {
    password += allChars.charAt(Math.floor(Math.random() * allChars.length));
  }
  
  // 文字列をシャッフル
  return password.split('').sort(() => 0.5 - Math.random()).join('');
};

/**
 * パスワードをクリップボードにコピーする
 * @param password コピーするパスワード
 * @returns コピーが成功したかどうか
 */
export const copyPasswordToClipboard = async (password: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(password);
    return true;
  } catch (error) {
    console.error('クリップボードへのコピーに失敗しました:', error);
    return false;
  }
};
